import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ACTION_PLAN_CONSTANTS } from "../../constants/ActionPlanConstants";
import { ListaSelect } from "../../models/ActionPlan.model";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";

@Component({
  name: "OutData",
  components: {
    DynamicSelect
  }
})
export default class OutData extends Vue {
  @Prop() pdfList!: ListaSelect[];
  @Prop() pdfArraySelect!: ListaSelect[];
  @Prop() loadingPdfList!: boolean;

  cardClass = STYLE_CLASSES.CARD_2;
  card2Class = STYLE_CLASSES.CARD_PADING;
  TITLES = ACTION_PLAN_CONSTANTS.TITLES;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;

  rules = {
    out: [FORM_VALIDATORS.REQUIRED_FIELD]
  };

  pdfListModel: any = [];

  dynamicSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: this.TITLES.TEMPLATE_PDF,
    hideDetails: true,
    rules: this.rules.out,
    loadingData: this.loadingPdfList
  };

  mounted() {
    this.setPdfList();
  }

  @Watch("pdfList")
  setPdfList() {
    this.dynamicSelectConfig.listAll = this.pdfList.map(item => {
      return {
        ...item,
        id: item.key
      };
    });
  }

  @Watch("loadingPdfList")
  setLoadingPdfList() {
    this.dynamicSelectConfig.loadingData = this.loadingPdfList;
  }

  get pdfLocal() {
    return this.pdfListModel[0] ? this.pdfListModel[0].id : null;
  }

  fetchPdfList(name?: string) {
    this.$emit(ACTION_PLAN_CONSTANTS.EMITTERS.FETCH_PDF_LIST, name);
  }

  @Watch("pdfListModel")
  emmitPdfArraySelect() {
    const data = this.pdfList.find(item => item.key == this.pdfLocal);
    this.$emit(ACTION_PLAN_CONSTANTS.EMITTERS.UPDATE_PDF_LIST, [data]);
  }
  @Watch("pdfArraySelect")
  changePdfArraySelect() {
    if (!this.pdfListModel[0] && this.pdfArraySelect[0]) {
      this.pdfListModel = this.pdfArraySelect.map(item => {
        return {
          ...item,
          id: item.key
        };
      });
    }
  }

  clearPdf() {
    this.$emit(ACTION_PLAN_CONSTANTS.EMITTERS.UPDATE_PDF_LIST, []);
  }
}
